<template lang="pug">
UiArticle.article(
  :title="$t('pages.ssr_privacy_policy.title')"
)
  MessageBox.info(
    type="info"
    slot="upper-header"
    :message="$t('pp_disclaimer')"
  )

  BLoading(
    :active="privacyInProgress"
    :can-cancel="false"
    :is-full-page="true"
  )

  .custom-page-content(
    v-html='content'
  )
</template>

<script>
import getMeta from '@/lib/meta'
import alternateLinks from '@/lib/alternate-links'
import { schemaMarkup } from '@/lib/schema-markup'

import MessageBox from '@/components/ui/elements/info/MessageBox'

export default {
  components: {
    MessageBox
  },

  layout: 'landing-light',

  middleware: [
    'languageRedirect'
  ],

  data () {
    return {
      content: '',
      cookiesContent: '',
      privacyInProgress: false,
      policy: {
        en: 'https://www.iubenda.com/api/privacy-policy/47080132/no-markup',
        es: 'https://www.iubenda.com/api/privacy-policy/34438859/no-markup',
        it: 'https://www.iubenda.com/api/privacy-policy/99724517/no-markup'
      },
      cookies: {
        en: 'https://www.iubenda.com/api/privacy-policy/47080132/cookie-policy/no-markup',
        es: 'https://www.iubenda.com/api/privacy-policy/34438859/cookie-policy/no-markup',
        it: 'https://www.iubenda.com/api/privacy-policy/99724517/cookie-policy/no-markup'
      }
    }
  },

  head () {
    const resultMeta = getMeta({
      title: this.$t('meta.ssr_privacy_policy.title'),
      metaTitle: this.$t('meta.ssr_privacy_policy.metaTitle'),
      description: this.$t('meta.homepage.description'),
      route: this.$route,
      i18nLocales: this.$i18n.locales,
      i18nSeo: this.$nuxtI18nSeo(),
      alternateLinks: alternateLinks.map(el => ({ title: this.$t(el.titleKey), href: el.href })),
      options: {
        gdpr: this.$store.state.auth.gdprThirdParty
      }
    })

    resultMeta.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaMarkup)
    })

    return resultMeta
  },

  async mounted () {
    this.privacyInProgress = true

    const privacyUrl = this.policy[this.$i18n.locale]

    const response = await this.$axios(privacyUrl)

    this.privacyInProgress = false

    if (response.data && response.data.success) {
      this.content = response.data.content
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  margin-bottom: $gap;
}
.custom-page-content {
  /deep/ ul {
    li {
      list-style: disc;
    }
  }
}
</style>
